'use strict';

import ProductQuickViewBase from 'org/components/product/ProductQuickView';

export default class ProductQuickView extends ProductQuickViewBase {
    init() {
        super.init();

        if ($('.g-modal-dialog.quick-add-dialog').length === 0) {
            this.showMoreLessColor();
        }
    }

    getSizeAttributesHtml(product) {
        if (!product.variationAttributes) {
            return '';
        }
        var html = '';
        var attrSelected = 'selectable m-active selected';
        var varitionTab = $('.pdp-open-new-tab', this.$el).attr('href');
        product.variationAttributes.forEach((attributeGroup) => {
            if (attributeGroup.attributeId === 'size') {
                attributeGroup.values.forEach((attribute) => {
                    html += `<li class="js-sizeAttributes swiper-slide" data-url="${attribute.url}">
                    <a href="${varitionTab || ''}" data-size-attr="${attribute.displayValue}" data-attr-value="${attribute.id}" role="button" class="js-size-select ${!attribute.selectable ? 'disabled' : ''} ${attribute.selected ? attrSelected : ''}`;
                    if (product.custom.gender && (product.custom.gender.toLowerCase() === 'unisex' || product.custom.gender.toLowerCase() === 'adult_unisex' || product.custom.gender.toLowerCase() === 'youth_unisex')) { // size chips values for unisex products
                        var useValue = attribute.value.toLowerCase() === 'osfa'; // if unisex product is of size osfa ,use the value instead and Removing the displayValue length check as it always takes the value and DisplayValue will be empty.
                        if (useValue) { // When using value, include displayValue as title.
                            html += ` f-unisex_sizechips">${attribute.displayValue ? attribute.displayValue : attribute.value}</a></li>`;
                        } else {
                            html += ` f-unisex_sizechips">${attribute.displayValue ? attribute.displayValue : attribute.value}</a></li>`;
                        }
                    } else { // for products with gender other than unisex
                        html += `">${attribute.displayValue ? attribute.displayValue : attribute.value}</a></li>`;
                    }
                });
            }
        });

        return html;
    }

    showMoreLessColor() {
        const lastVisibleClassName = 'last-visible';
        const visibleMobileRows = 2;
        const visibleDesktopRows = 2;

        $(this.$el).find('.b-product_attribute.m-color').each((i, el) => {
            const $colorSwatchBlock = $(el);
            const $swatchesListContainer = $colorSwatchBlock.find('.b-swatches_circle');
            const $colorSwatchItems = $colorSwatchBlock.find('.b-swatches_circle-item');
            const $colorSwatchActionCTAs = $colorSwatchBlock.find('.b-color-more_less');
            let initial = true;

            const calculateVisibleSwatches = () => {
                // in order to skip desktop version for mobile view
                if (!$colorSwatchItems.is(':visible')) {
                    return;
                }
                const swatchWidth = $colorSwatchItems.eq(0).width() || 0;
                const cssGap = $swatchesListContainer.css('column-gap') || '';
                const gap = Number(cssGap.replace(/[\D]/g, '')) || 0;
                const swatchesListContainerWidth = Math.floor($swatchesListContainer.width() || 0);
                let leftFreeRowSpace = swatchesListContainerWidth;
                let itemsInTheRow = 0;
                while (leftFreeRowSpace >= swatchWidth) {
                    leftFreeRowSpace -= (swatchWidth + gap);
                    itemsInTheRow += 1;
                }

                const visibleRows = $(window).width() < 1025 ? visibleMobileRows : visibleDesktopRows;
                const totalVisibleSwatches = visibleRows * itemsInTheRow;

                $colorSwatchItems.filter(`.${lastVisibleClassName}`).removeClass(lastVisibleClassName);
                if ($colorSwatchItems.length > totalVisibleSwatches) {
                    const lastVisibleIndex = (visibleRows * itemsInTheRow);
                    $colorSwatchItems.eq(lastVisibleIndex).addClass(lastVisibleClassName);

                    if (initial && lastVisibleIndex < $colorSwatchItems.filter('.swiper-slide-activated').eq(0).index()) {
                        $colorSwatchBlock.addClass('show-all');
                        $('body').trigger('product:showMoreFired', {
                            type: 'color',
                            name: 'product: showMoreFired'
                        });
                    }
                    $colorSwatchActionCTAs.removeClass('hide');
                } else {
                    $colorSwatchActionCTAs.addClass('hide');
                }
            };

            $(window).on('resize', () => {
                calculateVisibleSwatches();
            });
            calculateVisibleSwatches();

            $colorSwatchBlock.on('click', '.js-color-show-more', function () {
                $colorSwatchBlock.addClass('show-all');
                initial = false;

                $('body').trigger('product:showMoreFired', {
                    type: 'color',
                    name: 'product: showMoreFired'
                });
            });
            $colorSwatchBlock.on('click', '.js-color-show-less', function () {
                $colorSwatchBlock.removeClass('show-all');
                initial = false;
            });
        });
    }
}
